import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/core/entities/api-response.entity/api-response';
import { ApiService } from 'src/app/core/services/api.service/api.service';
import { PediatricChild } from 'src/app/entities/pediatric-child.entity/pediatric-child';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PediatricChildSettingsService extends ApiService {

  switchAlert(id: string) {
    return this.http.patch<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}/alert`, {}).pipe(this.responsePipe);
  }

  switchActivation(id: string) {
    return this.http.patch<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}/activation`, {}).pipe(this.responsePipe);
  }

  all(): Observable<Array<PediatricChild>> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric`).pipe(this.responsePipe);
  }

  one(id: string): Observable<PediatricChild> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}`).pipe(this.responsePipe);
  }

  add(pediatricchild: PediatricChild): Observable<PediatricChild> {
    return this.http.post<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric`, pediatricchild.requestPayload).pipe(this.responsePipe);
  }

  update(id: string, updates: Partial<PediatricChild>): Observable<PediatricChild> {
    return this.http.put<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}`, updates.requestPayload).pipe(this.responsePipe);
  }

  delete(id: string): Observable<PediatricChild> {
    return this.http.delete<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}`).pipe(this.responsePipe);
  }

}

@Injectable({
  providedIn: 'root'
})
export class PediatricChildSettingService extends ApiService {

 switchAlert(id: string) {
    return this.http.patch<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}/alert`, {}).pipe(this.responsePipe);
  }

  switchActivation(id: string) {
    return this.http.patch<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}/activation`, {}).pipe(this.responsePipe);
  }

  all(): Observable<Array<PediatricChild>> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric`).pipe(this.responsePipe);
  }

  one(id: string): Observable<PediatricChild> {
    return this.http.get<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}`).pipe(this.responsePipe);
  }

  add(pediatricchild: PediatricChild): Observable<PediatricChild> {
    return this.http.post<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric`, pediatricchild.requestPayload).pipe(this.responsePipe);
  }

  update(id: string, updates: Partial<PediatricChild>): Observable<PediatricChild> {
    return this.http.put<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}`, updates.requestPayload).pipe(this.responsePipe);
  }

  delete(id: string): Observable<PediatricChild> {
    return this.http.delete<ApiResponse>(`${environment.API_URL}/doctor/settings/consultation/child/pediatric/${id}`).pipe(this.responsePipe);
  }

}
